module.exports = __webpack_public_path__ + "img/UT0383.a772b7d2.png";